import {Component,OnInit,ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {NotificationMailsService} from "./notification-mails.service";
import {TypeService,TypeCryptage} from "@domain/admin/bibliotheque/notification/config-smtp";


/**
 * Onglet notification mails
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'notification-mails'},
    templateUrl: './notification-mails.component.html',
    providers: [
        NotificationMailsService
    ]
})
export class NotificationMailsComponent implements OnInit {
    /** Formulaire */
    @ViewChild('form') form: NgForm;

    /** Liste des types de service pour le select */
    listeTypeService: Array<{ type: TypeService, libelle: string }> = [
        {
            type: TypeService.SMTP,
            libelle: this.translateService.instant("admin.bibliotheque.notifications.envoiMails.typeService.smtp")
        },
        {
            type: TypeService.API,
            libelle: this.translateService.instant("admin.bibliotheque.notifications.envoiMails.typeService.api")
        }
    ];

    /** Liste des types de chiffrement pour le select */
    listeTypeCryptage: Array<{ type: TypeCryptage, libelle: string }> = [
        {
            type: TypeCryptage.NONE,
            libelle: this.translateService.instant("admin.bibliotheque.notifications.envoiMails.typeCryptage.aucun")
        },
        {
            type: TypeCryptage.STARTTLS,
            libelle: this.translateService.instant("admin.bibliotheque.notifications.envoiMails.typeCryptage.starttls")
        },
        {
            type: TypeCryptage.TLS_SSL,
            libelle: this.translateService.instant("admin.bibliotheque.notifications.envoiMails.typeCryptage.tlsSsl")
        }
    ];

    /** Liste des actions du floating-button */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     *
     * @param notificationMailsService Service de gestion de la configuration mails
     * @param translateService Service de traduction
     */
    constructor(
        public notificationMailsService: NotificationMailsService,
        private translateService: TranslateService,
    ) {
    }

    /**
     * Initialisation
     */
    ngOnInit(): void {
        //Initialisation des actions du floating-button
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-sauvegarde',
            libelle: 'global.actions.enregistrer',
            doAction: () => this.notificationMailsService.save(),
            isDisabled: () => !this.form?.valid
        }]);
    }
}